module.exports = __webpack_public_path__ + "static/media/cart-down.9c0f2369.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/cart-down.svg
// module id = 1603
// module chunks = 1